export class FormulaLearned {
    public id = '';
    public source = '';
    public snareSpecialistPrepared = 0;
    public snareSpecialistAvailable = 0;
    recast() {
        return this;
    }
}
